function getCoreComponent(Component) {
  let node = Component;
  while (node.WrappedComponent) {
    node = node.WrappedComponent;
  }
  return node;
}
export function attachWrappedComponent(Decorator, WrappedComponent) {
  Decorator.WrappedComponent = WrappedComponent;
  Decorator.CoreComponent = getCoreComponent(WrappedComponent);
}
export function generatePersistentQueryKey(portalId, pathname, userId) {
  return `workflows-persist-query-${portalId}-${userId}-${pathname}`;
}